import { render, staticRenderFns } from "./temperatures.vue?vue&type=template&id=3fd27bca&scoped=true&"
import script from "./temperatures.vue?vue&type=script&lang=js&"
export * from "./temperatures.vue?vue&type=script&lang=js&"
import style0 from "./temperatures.vue?vue&type=style&index=0&id=3fd27bca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd27bca",
  null
  
)

export default component.exports